import { startOfDay } from 'date-fns'

const ORDER_LEAD_DAYS = 3
export const ALLOWED_APP_VERSION_EMAILS = ['k.stefanczyk@invotech.co', 'd.konkol@invo.ventures']

export const ORDER_EARLIEST_START_DATE = computed(() =>
	startOfDay(new Date(new Date().setDate(new Date().getDate() + ORDER_LEAD_DAYS))),
)
